/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  ManagerLogicCommon,
  ManagerLogicCommonInterface,
} from "../../../contracts/manager/ManagerLogicCommon";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lpUsdtPrice",
        type: "uint256",
      },
    ],
    name: "_lpToUsd",
    outputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stfUsdtPrice",
        type: "uint256",
      },
    ],
    name: "_usdToStf",
    outputs: [
      {
        internalType: "uint256",
        name: "stf",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdtStfLpAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "usdsStfLpPrice",
        type: "uint256",
      },
    ],
    name: "_usdsStfLpToUsd",
    outputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ManagerLogicCommonConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ManagerLogicCommonConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ManagerLogicCommon__factory extends ContractFactory {
  constructor(...args: ManagerLogicCommonConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ManagerLogicCommon> {
    return super.deploy(overrides || {}) as Promise<ManagerLogicCommon>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ManagerLogicCommon {
    return super.attach(address) as ManagerLogicCommon;
  }
  override connect(signer: Signer): ManagerLogicCommon__factory {
    return super.connect(signer) as ManagerLogicCommon__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManagerLogicCommonInterface {
    return new utils.Interface(_abi) as ManagerLogicCommonInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManagerLogicCommon {
    return new Contract(address, _abi, signerOrProvider) as ManagerLogicCommon;
  }
}
